import {CustomerCareError} from './CustomerCareError.js'

export class CheckOpenHoursCustomerCareError extends CustomerCareError {}
